import { render, staticRenderFns } from "./LabElementCreate.vue?vue&type=template&id=15548719"
import script from "./LabElementCreate.vue?vue&type=script&lang=js"
export * from "./LabElementCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports